<script setup lang="ts">
// Single-mount wrapper around the activation drawer. The shell renders
// this once; opening the drawer happens via the activation-bus
// (openActivationGate). Architecture §11.4 keeps activation embedded in
// the shell because it's an overlay triggered from other features.
import ActivationGateDrawer from './ActivationGateDrawer.vue';
</script>

<template>
  <ActivationGateDrawer />
</template>
